import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { LoadingOutlined } from '@ant-design/icons';
import styles from './Loader.less';

const Loader = ({ spinning, fullScreen }) => {
  return (
    <div
      className={classNames(styles.loader, {
        [styles.hidden]: !spinning,
        [styles.fullScreen]: fullScreen,
      })}
    >
      <LoadingOutlined className={styles.spin} spin />
      {/*<div className={styles.warpper}>*/}
      {/*<div className={styles.inner} />*/}
      {/*</div>*/}
    </div>
  );
};

Loader.propTypes = {
  spinning: PropTypes.bool,
  fullScreen: PropTypes.bool,
};

export { Loader };
